<template>
  <div v-if="survey[$route.params.survey]">

    <div class="card">
      <div class="card-top">
        <div class="icon-box" :style="'background-image:url('+survey[$route.params.survey].topbillede2+')'">
          <svg width="522" height="252" viewBox="0 0 522 252" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fill-rule="evenodd">
              <path d="M396.91 192l55.754 55.755c3.906 3.905 10.237 3.905 14.142 0L522 192.561V252H0v-60h396.91z" fill="#BC171D"/>
              <path d="M284.806 0L251.93 32.877c-3.905 3.906-3.905 10.237 0 14.143L396.909 192H0V0h284.806z" fill="#BC171D"/>
            </g>
          </svg>
        </div>
        <div class="logo-box" v-html="globalC.logo">

        </div>
        <div class="card-top-content">
          <div class="inside">
            <div class="kicker">{{survey[$route.params.survey].name}}</div>
            <div v-html="compiledMarkdown(survey[$route.params.survey].content)"></div>
          </div>
        </div>
      </div>
    </div>
    <span id="start" style="position:relative;top:-30px;"></span>
    <transition name="expand">
      <div v-if="beginFlow">
        <app-SoftPermissionEmail v-if="firm.userid"></app-SoftPermissionEmail>
        <app-PermissionEmail v-else :data="compiledMarkdown(survey[$route.params.survey].helper)"></app-PermissionEmail>
      </div>
    </transition>
    <div class="card" v-if="!beginFlow">
      <div class="card-bottom">
        <div class="card-bottom-inside">

          <div class="card-2col">
            <div class="card-col">
              <a  v-if="!beginFlow && !$route.query.noform" class="btn-light" @click.prevent.default="setBeginFlow" v-scroll-to="'#start'">
                Kom i gang
              </a>
              <a v-if="beginFlow || $route.query.noform" href=""  @click.prevent.default="startSurvey()" class="btn-light">
                Start sikkerhedstjekket
              </a>
            </div>
            <div class="card-col" v-html="compiledMarkdown(survey[$route.params.survey].helper)">

            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="card">
      <div class="module-why">
        <div class="module-why-intro">
          <div v-html="compiledMarkdown(survey[$route.params.survey].content2)">
          </div>
        </div>
        <div class="module-why-image">
          <img :src="survey[$route.params.survey].content2billede" alt="">
        </div>
      </div>
      <div class="module-get">
        <div class="module-get-image">
          <img :src="survey[$route.params.survey].content3billedeA" alt="" v-if="!survey[$route.params.survey].showallcompanys">
          <img :src="survey[$route.params.survey].content3billedeB" alt="" v-if="survey[$route.params.survey].showallcompanys">
        </div>
        <div class="module-get-intro">

          <div v-html="compiledMarkdown(survey[$route.params.survey].content3)">
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div style="background-color:#fff;height:100px;">

      </div>
    </div>
    <app-xperts></app-xperts>
    <app-cfooter></app-cfooter>
    <div class="Cookie--base-wrapper">
      <cookie-law buttonText="Ok!">
        <div slot="message">
          Hjemmesiden bruger cookies. Cookies er nødvendige for at få hjemmesiden til at fungere, og for at give dig den bedst mulige oplevelse. <a target="_blank" href="https://www.falck.dk/om-falck/kontakt/cookies/cookie-og-persondatapolitik/">Læs mere her.</a>
        </div>
      </cookie-law>
    </div>

  </div>
</template>

<script>

import Cfooter from '@/components/modular/cfooter.vue';
import Xperts from '@/components/modular/xperts.vue';
import Logo from '@/components/modular/logo.vue';
import SoftPermissionEmail from '@/components/extended/softPermissionEmail.vue';
import PermissionEmail from '@/components/extended/permissionEmail.vue';

import Marked from 'marked';
import {mapGetters} from 'vuex';
import {mapSetters} from 'vuex';
import {mapActions} from 'vuex';
import {db} from '@/database/firebase';
import CookieLaw from 'vue-cookie-law'

export default {
  survey: 'Brand',
  components:{
    appSoftPermissionEmail: SoftPermissionEmail,
    appPermissionEmail: PermissionEmail,
    appCfooter: Cfooter,
    appXperts: Xperts,
    CookieLaw
  },
  data () {
    return {
      msg: 'Overskrift',
    }
  },
  computed: {
    ...mapGetters([
      'survey',
      'whatPop',
      'globalC',
      'spinner',
      'surveyIsActive',
      'firm',
      'beginFlow',
      "squareMetersCounter",
      "locationCounter",
      "employeesCounter"
    ])
  },
  methods: {
    ...mapActions([
      'setSurveyActive',
      'setFirm',
      'setBeginFlow'
    ]),
    compiledMarkdown(text) {
      return Marked(text, { sanitize: true })
    },
    setVisited () {
      localStorage.setItem('cookie:accepted', true)
    },
    startSurvey(){
      this.firm.firmId = Date.now();
      this.setVisited();
      this.$router.push({ path: '/survey/v2/'+this.$route.params.survey+'/before' })
    }
  },
  mounted() {
    this.setSurveyActive(true);
    this.firm.firmId = "";
    window.scrollTo(0, 0);
    if(this.$route.query.noform){
      console.log(this.$route.query.noform);
      this.$store.state.global.firm.noform = this.$route.query.noform
    }
    if(this.$route.query.uid){
      console.log(this.$route.query.uid);
      this.$store.state.global.firm.userid = this.$route.query.uid
    }
    if(this.$route.query.sid){
      console.log(this.$route.query.sid);
      this.$store.state.global.firm.saelgerid = this.$route.query.sid
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.grid{
  margin-top: 7rem;
}
.card-top{
  height:auto;
  background-color: #BC171D;
}

.card-top-content {
    background-color: #BC171D;
    border-bottom: 0px;
    height: auto;
    min-height: 252px;
}
.btn-light{
  display: block;
  max-width: 66%;
  @media(max-width: 1023px){
    max-width: 100%;
  }
}
.card-bottom{
  display: flex;
  margin-top:-1px;
  align-items: center;
}



@media (max-width: 1023px){
  .card-top-content .inside {
      padding: 78px 16px 10px;
  }
  .card-bottom{
    padding-top: 20px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/extended/extended-survey.vue